import { Building } from 'store/building/types';
import { BuildingContext } from 'store/serviceProviders/types';
import { FailureActionPayload } from 'store/errors/types';
import { createAction, createAsyncAction } from 'typesafe-actions';

export const getBuilding = createAsyncAction('GET_BUILDING_REQUEST', 'GET_BUILDING_SUCCESS', 'GET_BUILDING_FAILURE')<
  [undefined, undefined],
  Building,
  FailureActionPayload
>();

/**
 * Sets service building context from providers response.
 * Used for cross-building bookings to get service building's timezone/currency.
 */
export const setServiceBuildingFromContext = createAction('SET_SERVICE_BUILDING_FROM_CONTEXT')<BuildingContext>();

/**
 * Clears service building context.
 * Used when switching to same-building bookings to prevent stale timezone/currency.
 */
export const clearServiceBuilding = createAction('CLEAR_SERVICE_BUILDING')();
